import { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { checkRole } from "../helpers/checkRoles"; // Asegúrate de que la ruta es correcta

export const useCheckRole = (requiredRole: string) => {
  const [hasRole, setHasRole] = useState(false);
  const [isCheckingRole, setIsCheckingRole] = useState(true);
  const [error, setError] = useState<any>(null);

  useEffect(() => {
    const verifyRole = async () => {
      setIsCheckingRole(true);
      const token = Cookies.get("token");
      if (!token) {
        setError("No token found");
        setIsCheckingRole(false);
        return;
      }

      try {
        const roleCheck = await checkRole(token, requiredRole);
     
        setHasRole(roleCheck);
      } catch (err: any) {
        setError(err.message || "An error occurred");
      } finally {
        setIsCheckingRole(false);
      }
    };

    verifyRole();
  }, [requiredRole]);

  return { hasRole, isCheckingRole, error };
};
